export function CheckMark({
  className = '',
  style = null,
  color = 'white',
  opacity = 0.7
}) {
  return (
    <div className={`icon ${className}`} style={style}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_462_812)">
          <path d="M16 16H8C3.58867 16 0 12.4113 0 8C0 3.58867 3.58867 0 8 0C12.4113 0 16 3.58867 16 8V16ZM8 0.666667C3.95667 0.666667 0.666667 3.95667 0.666667 8C0.666667 12.0433 3.95667 15.3333 8 15.3333H15.3333V8C15.3333 3.95667 12.0433 0.666667 8 0.666667ZM7.68133 10.366L12.416 5.69133L11.9473 5.21733L7.21133 9.89333C7.07333 10.0313 6.83733 10.034 6.69467 9.89067L4.05133 7.30733L3.58533 7.784L6.226 10.3647C6.42 10.5593 6.67933 10.6667 6.95467 10.6667C7.23 10.6667 7.48867 10.5593 7.68133 10.366Z" fill={color} fillOpacity={opacity} />
        </g>
        <defs>
          <clipPath id="clip0_462_812">
            <rect width="16" height="16" fill={color}/>
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}
